import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Youtube(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.797 8.02S21.6 6.649 21 6.047c-.762-.793-1.613-.797-2.004-.844C16.2 5 12 5 12 5h-.008s-4.199 0-6.996.202c-.39.047-1.242.05-2.004.844C2.392 6.648 2.2 8.02 2.2 8.02S2 9.63 2 11.244v1.508c0 1.61.2 3.223.2 3.223s.195 1.372.792 1.975c.762.793 1.762.766 2.207.852C6.801 18.953 12 19 12 19s4.203-.008 7-.206c.39-.047 1.242-.05 2.004-.843.601-.603.797-1.975.797-1.975s.199-1.61.199-3.223v-1.509c-.004-1.61-.203-3.223-.203-3.223zM9.93 14.584V8.99l5.402 2.807-5.402 2.787z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Youtube);
export default ForwardRef;